<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div data-test="barn-item" class="wrapper--spacing-vertical">
    <form [formGroup]="formGroup">
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'settings.barn-item.name' | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'settings.barn-item.name' | translate }}"
            formControlName="name"
            data-test="barn-item__name"
          />
          <mat-error
            *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.duplicateName"
          >
            {{ 'settings.barn-item.error-name-duplicate' | translate }}
          </mat-error>
          <mat-error
            *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.required"
          >
            {{ 'settings.barn-item.error-name-required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'settings.barn-item.area' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.0001"
            placeholder="{{ 'settings.barn-item.area' | translate }}"
            formControlName="surfaceArea"
            data-test="barn-item__surface-area"
          />
          <span matTextSuffix class="form-field-suffix">m2</span>
          <mat-error *ngIf="formGroup.controls.surfaceArea.invalid">
            {{ 'settings.barn-item.error-surface-area' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="silos$ | async as silos">
          <mat-label>{{ 'settings.barn-item.silo' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            multiple
            placeholder="{{ 'settings.barn-item.silo' | translate }}"
            formControlName="silo"
            data-test="barn-item__silo"
          >
            <mat-option *ngFor="let silo of silos" [value]="silo">
              {{ silo.siloNumber }} - {{ silo.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.controls.silo.errors?.required">
            {{ 'required-error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
</agr-form-dialog>
